'use client';

import applicationMonitoring from '$utils/monitoring';
import { applyPromisePolyfill } from '@brahma/utils';
import type React from 'react';

// Apply Promise.withResolvers polyfill for older browsers (Opera 89, Chrome <119, etc.)
// This runs at module load time, ensuring it's available before PDF.js or other code needs it
applyPromisePolyfill();
if (process.env.NEXT_PUBLIC_ENABLE_RUM) {
  applicationMonitoring.init();
}
const MonitoringHelper: React.FC = () => {
  return null;
};
export default MonitoringHelper;